import { Spacing } from '@billy/design-system'
import { css } from '@emotion/core'

export const getCellStyles = () => {
  return css`
    text-align: right;
    padding: ${Spacing.S12} ${Spacing.S16};

    &:first-child,
    &:nth-child(2) {
      text-align: left;
    }

    &:nth-child(2) {
      padding-left: 0;
    }
  `
}
